







































































































































































































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import { QuestionItemForm, QuestionOptionForm } from "@/serve/question/question";

@Component({
  name: "questionItem"
})
export default class QuestionItem extends Vue {
  @Prop({ default: false }) public visible!: boolean;
  @Prop({ required: true }) public title!: string;
  @Prop({ required: true }) public itemForm!: QuestionItemForm;
  @Prop({ default: () => [] }) public parentItemOptions!: QuestionItemForm[];
  @Prop({ default: false }) public hasParentItem!: boolean;
  @Prop({ default: false }) public submitLoading!: boolean;
  @Prop({ default: "" }) public quickOptionText!: string;
  @Prop({ required: true }) public beforeImageUpload!: (file: { type: string; size: number }) => boolean;
  @Prop({ required: true }) public uploadItemImage!: (res: { file: File }) => Promise<void>;
  @Prop({ required: true }) public uploadOptionImage!: (option: QuestionOptionForm) => (res: { file: File }) => Promise<void>;

  public get innerVisible() {
    return this.visible;
  }

  public set innerVisible(value: boolean) {
    this.$emit("update:visible", value);
  }

  public get innerQuickOptionText() {
    return this.quickOptionText;
  }

  public set innerQuickOptionText(value: string) {
    this.$emit("update:quickOptionText", value);
  }

  public parentItemLabel(item: QuestionItemForm) {
    return `${item.itemCode || ""} ${item.itemTitle || ""}`.trim();
  }

  public submitForm() {
    (this.$refs.itemForm as any).validate((valid: boolean) => {
      if (valid) {
        this.$emit("submit");
      }
    });
  }

  public clearValidate() {
    const formRef = this.$refs.itemForm as any;
    if (formRef) {
      formRef.clearValidate();
    }
    this.$emit("closed");
  }

  private itemRules = {
    itemCode: [{ required: true, message: "请输入题目编码", trigger: "blur" }],
    itemTitle: [{ required: true, message: "请输入题目标题", trigger: "blur" }],
    itemType: [{ required: true, message: "请选择题目类型", trigger: "change" }]
  };
}
